<template v-if="data">
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">Add New Delivery Order</h4>
                    </div>
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="createDo" icon="save">Create DO</vs-button>
                </div>
                <div class="vx-row mt-6">
                    <div class="vx-col lg:w-1/4 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Outbound Reference*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="data.outbound.outbound_reference" disabled/>
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                DO Reference*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="do_reference" />
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Request Delivery Date*
                            </div>
                            <div class="vx-col w-2/3">
                                <flat-pickr class="w-full" v-model="data.outbound.req_del_date" disabled/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Client*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.outbound.client_id"
                                    width="100%"
                                    autocomplete
                                    disabled
                                >
                                    <vs-select-item v-for="(item, index) in client.data" :key="index" :value="item.id" :text="item.client_code"/>
                                </vs-select>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col lg:w-1/4 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Origin*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.outbound.origin_id"
                                    width="100%"
                                    autocomplete
                                    disabled
                                >
                                    <vs-select-item v-for="(item, index) in customer.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Address
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="data.outbound.origin.address_1" :disabled="true"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                &nbsp;
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="data.outbound.origin.address_2" :disabled="true"/>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col lg:w-1/4 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Destination*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.outbound.destination_id"
                                    width="100%"
                                    autocomplete
                                    disabled
                                >
                                    <vs-select-item v-for="(item, index) in customer.data" :key="index" :value="item.id" :text="item.name"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Address
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="data.outbound.destination.address_1" :disabled="true"/>
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                &nbsp;
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="data.outbound.destination.address_2" :disabled="true"/>
                            </div>
                        </div>
                    </div>
                    <div class="vx-col lg:w-1/4 w-full">
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Outbound Status
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full mb-1" v-model="do_status" disabled/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                Order Type*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-select
                                    class="selectExample"
                                    v-model="data.outbound.order_type_id"
                                    width="100%"
                                    autocomplete
                                    disabled
                                >
                                    <vs-select-item v-for="(item, index) in order_type.data" :key="index" :value="item.id" :text="item.order_type"/>
                                </vs-select>
                            </div>
                        </div>
                        <div class="vx-row mb-3 mt-1">
                            <div class="vx-col w-1/3">
                                Posting Date
                            </div>
                            <div class="vx-col w-2/3">
                                <flat-pickr class="w-full" v-model="posting_date" />
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                PO Reference*
                            </div>
                            <div class="vx-col w-2/3">
                                <vs-input class="w-full" v-model="data.outbound.po_reference" disabled/>
                            </div>
                        </div>
                        <div class="vx-row mb-3">
                            <div class="vx-col w-1/3">
                                PO Date
                            </div>
                            <div class="vx-col w-2/3">
                                <flat-pickr class="w-full" v-model="data.outbound.po_date" disabled/>
                            </div>
                        </div>
                    </div>
                </div>
                <vs-tabs class="mt-10">
                    <vs-tab label="Item Details">
                        <div style="overflow-y: auto;">
                            <table cellspacing="5">
                                <thead>
                                    <tr>
                                        <th style="width: 1%">Line ID</th>
                                        <th style="width: 10%">Warehouse</th>
                                        <th style="width: 10%">Product</th>
                                        <th style="width: 10%">Description</th>
                                        <th style="width: 5%">Pack ID</th>
                                        <th style="width: 5%">Batch</th>
                                        <th style="width: 5%">Box ID</th>
                                        <th style="width: 10%">Exp. Date</th>
                                        <th style="width: 5%">Qty</th>
                                        <th style="width: 5%">UoM</th>
                                        <th style="width: 10%">Stock Type</th>
                                        <th style="width: 5%">Picked Qty</th>
                                        <th style="width: 5%">Open Qty</th>
                                        <th style="width: 5%">Base Qty</th>
                                        <th style="width: 5%">Base UoM</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(detail, index) in data.outbounddetails" :key="index">
                                        <td>
                                            <vs-input class="w-full" v-model="detail.line_id" :disabled="true"/>
                                        </td>
                                        <td>
                                            <vs-select
                                                class="selectExample"
                                                v-model="detail.warehouse_id"
                                                width="100%"
                                                autocomplete
                                                disabled
                                            >
                                                <vs-select-item v-for="(item, index) in detail.warehouseOptions" :key="index" :value="item.value" :text="item.text"/>
                                            </vs-select>
                                        </td>
                                        <td>
                                            <vs-select
                                                class="selectExample"
                                                v-model="detail.product_id"
                                                width="100%"
                                                autocomplete
                                                disabled
                                            >
                                                <vs-select-item v-for="(item, index) in detail.productOptions" :key="index" :value="item.value" :text="item.text"/>
                                            </vs-select>
                                        </td>
                                        <td>
                                            <vs-input class="w-full" v-model="detail.product.description_1" :disabled="true"/>
                                        </td>
                                        <td>
                                            <vs-input class="w-full" v-model="detail.pack_id" disabled/>
                                        </td>
                                        <td>
                                            <vs-input class="w-full" v-model="detail.batch" disabled/>
                                        </td>
                                        <td>
                                            <vs-input class="w-full" v-model="detail.box_id" disabled/>
                                        </td>
                                        <td>
                                            <flat-pickr class="w-full" v-model="detail.expired_date" disabled/>
                                        </td>
                                        <td>
                                            <vs-input class="w-full" v-model="detail.qty" @input="convertQty(detail)" disabled/>
                                        </td>
                                        <td>
                                            <vs-select
                                                class="selectExample"
                                                v-model="detail.uom_id"
                                                width="100%"
                                                autocomplete
                                                disabled
                                                @change="convertQty(detail)"
                                                @input="uomChange(detail)"
                                            >
                                                <vs-select-item v-for="(item, index) in detail.uomOptions" :key="index" :value="item.value" :text="item.text"/>
                                            </vs-select>
                                        </td>
                                        <td>
                                            <vs-select
                                                class="selectExample"
                                                v-model="detail.stock_type_id"
                                                width="100%"
                                                autocomplete
                                                disabled
                                            >
                                                <vs-select-item v-for="(item, index) in detail.stockTypeOptions" :key="index" :value="item.value" :text="item.text"/>
                                            </vs-select>
                                        </td>
                                        <td>
                                            <vs-input class="w-full" v-model="detail.picked_qty" :disabled="true"/>
                                        </td>
                                        <td>
                                            <vs-input class="w-full" v-model="detail.open_qty" :disabled="true"/>
                                        </td>
                                        <td>
                                            <vs-input class="w-full" v-model="detail.base_qty" disabled/>
                                        </td>
                                        <td>
                                            <vs-select
                                                class="selectExample"
                                                v-model="detail.base_uom_id"
                                                width="100%"
                                                autocomplete
                                                :disabled="true"
                                            >
                                                <vs-select-item v-for="(item, index) in detail.defaultUom" :key="index" :value="item.value" :text="item.text"/>
                                            </vs-select>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </vs-tab>
                    <vs-tab label="Transport and Unloading"></vs-tab>
                    <vs-tab label="External Notes">
                        <vs-textarea height="200" class="mt-5" label="External Notes"/>
                    </vs-tab>
                    <vs-tab label="Internal Notes">
                        <vs-textarea height="200" class="mt-5" label="Internal Notes"/>
                    </vs-tab>
                </vs-tabs>
            </vs-card>
        </div>
    </div>
</template>

<script>
	import vSelect from 'vue-select'
	import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

	export default {
		components:{
			vSelect,
			flatPickr,
		},
		data(){
			return {
                isLoading: false,
                detailsCount: 0,
                data: {
                    outbound: {
                        outbound_reference: '',
                        destination: {
                            address_1: '',
                            address_2: '',
                        },
                        origin: {
                            address_1: '',
                            address_2: '',
                        }
                    },
                    outbounddetails: []
                    
                },
                maxRetry: 10,
                orderTypeOptions: [],
                clientOptions: [],
                customerOptions: [],
                selectedId: null,
                do_status: 'Uncommitted',
                do_reference: '',
                stockTypeOptions: [],
                warehouseOptions: [],
                productOptions: [],
                posting_date: new Date(),
                client: {
                    data: [],
                    loading: false,
                    endpoint: 'master/clients',
                    objectKey: 'client_code'
                },
                customer: {
                    data: [],
                    loading: false,
                    endpoint: 'master/customers',
                    objectKey: 'name'
                },
                order_type: {
                    data: [],
                    loading: false,
                    endpoint: 'master/ordertypes',
                    objectKey: 'order_type'
                },
			}
        },
        watch: {
            isLoading: function(){
                if(this.isLoading){
                    this.$vs.loading()
                }
                else{
                    this.$vs.loading.close()
                }
            }
        },
        methods:{
            fetchData(api) {
                return this.$http.get(api)
            },
            submitForm() {
                if(!this.do_reference) {
                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error saving',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: 'Error saving, reference is required'
                    })
                    return;
                }

                for(let detail of this.data.outbounddetails){
                    if(detail.base_qty <= 0 || detail.qty <= 0) {
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error saving',
                            iconPack: 'feather',
                            icon:'icon-x',
                            text: 'Error saving, qty cannot be lower than 1. Line ' + detail.line_id
                        })
                        return;
                    }

                    if(detail.base_qty > detail.open_qty_fixed) {
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error saving',
                            iconPack: 'feather',
                            icon:'icon-x',
                            text: 'Error saving, base qty cannot be higher than open qty. Line ' + detail.line_id
                        })
                        return;
                    }
                }

                const do_head = {
                    do_reference: this.do_reference,
                    outbound_id: this.$route.params.id,
                    do_status: 4,
                    posting_date: this.posting_date,
                }

                const details = this.data.outbounddetails
                const dataSend = {
                    delivery_order: do_head,
                    details: details
                }

                this.isLoading = true
                this.$http.post('outbound/deliveryorder/createdo', dataSend)
                .then(res => {
                    this.$vs.notify({
                        color: 'success',
                        title: 'Saved Successfully',
                        iconPack: 'feather',
                        icon:'icon-check',
                        text: 'Delivery order added'
                    })
                    this.$router.push({ path: '/delivery-order' })
                })
                .catch(error => {
                    console.log(error)
                    if(error.response.data.message) {
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error saving',
                            iconPack: 'feather',
                            icon:'icon-x',
                            text: error.response.data.message
                        })
                    }
                    else {
                        this.$vs.notify({
                            color: 'danger',
                            title: 'Error saving',
                            iconPack: 'feather',
                            icon:'icon-x',
                            text: 'Something went wrong'
                        })
                    }
                })
                .then(() => {
                    this.isLoading = false
                })
            },
            back() {
                if(this.data.name != '' || this.data.client_code != '' || this.data.address_1 != '' ||  this.data.address_2 != '' || this.data.area_id != '' || this.data.city != '' || this.data.post_code != '' || this.data.clienttype_id != '') {
                    this.$vs.dialog({
                        color: 'warning',
                        title: 'Leave Page',
                        text: 'Changes you made may not be saved?',
                        acceptText: 'Leave Page',
                        accept: () => this.$router.go(-1),
                    })
                }
                else{
                    this.$router.go(-1)
                }
            },
            fetchAllData() {
                this.isLoading = true
                this.maxRetry = this.maxRetry - 1
                Promise.all([this.fetchData('outbound/outbounddelivery/show/' + this.$route.params.id), this.$http.post('outbound/deliveryorder/getremainingdetails', {'outbound_id': this.$route.params.id})])
                .then(this.$http.spread((res, details) => {
                    this.data = res.data
                    this.data.outbounddetails = details.data
                    this.client.data.push(res.data.outbound.client)
                    this.customer.data.push(res.data.outbound.origin)
                    this.customer.data.push(res.data.outbound.destination)
                    this.order_type.data.push(res.data.outbound.order_type)
                    res.data.outbounddetails.map((detail, index) => {
                        this.data.outbounddetails[index].uomOptions = []
                        this.data.outbounddetails[index].uom_list.map(uom => {
                            this.data.outbounddetails[index].uomOptions.push({
                                value: uom.uom.id,
                                text: uom.uom.name,
                                numerator: uom.numerator,
                                denominator: uom.denominator
                            })
                        })

                        this.data.outbounddetails[index].defaultUom = [
                            {
                                value: detail.base_uom.id,
                                text: detail.base_uom.name,
                            }
                        ]

                        this.data.outbounddetails[index].productOptions = [
                            {
                                value: detail.product.id,
                                text: detail.product.product_code
                            }
                        ]

                        this.data.outbounddetails[index].stockTypeOptions = [
                            {
                                value: detail.stock_type.id,
                                text: detail.stock_type.name
                            }
                        ]

                        this.data.outbounddetails[index].warehouseOptions = [
                            {
                                value: detail.warehouse.id,
                                text: detail.warehouse.warehouses_code
                            }
                        ]

                        this.data.outbounddetails[index].base_qty = detail.open_qty
                        this.data.outbounddetails[index].outbound_line_id = detail.id
                        this.data.outbounddetails[index].picked_qty = 0
                        this.data.outbounddetails[index].numerator = 0
                        this.data.outbounddetails[index].denominator = 0
                        this.data.outbounddetails[index].open_qty_fixed = this.data.outbounddetails[index].open_qty

                        this.uomChange(this.data.outbounddetails[index])
                    })

                    this.isLoading = false
                }))
                .catch(() => {
                    if(this.maxRetry < 0){
                        this.isLoading = false
                        this.$vs.dialog({
                            type: 'confirm',
                            color: 'danger',
                            title: 'Server Error',
                            text: 'Try again?',
                            accept: () => {
                                this.fetchAllData()
                                this.maxRetry = 10
                            },
                            cancel: () => this.$router.go(-1),
                            acceptText: 'Yes',
                            cancelText: 'No'
                        })
                        return;
                    }
                    this.fetchAllData()
                })
            },
            uomChange(detail) {
                detail.uomOptions.map(uom => {
                    if(uom.value == detail.uom_id) {
                        detail.denominator = uom.denominator
                        detail.numerator = uom.numerator
                    }
                })
            },
            removeDetail(index){
                this.data.outbounddetails.splice(index, 1)
            },
            convertQty(detail){
                detail.base_qty = (detail.qty / detail.denominator) * detail.numerator
                detail.open_qty = detail.open_qty_fixed - detail.base_qty
            },
            createDo() {
                this.isLoading = true
                const dataSend = {
                    'outbound_id': this.data.outbound.id,
                    'client_id': this.data.outbound.client_id
                }

                this.$http.post('outbound/deliveryorder', dataSend)
                .then(res => {
                    this.isLoading = false
                                            
                    this.$vs.notify({
                        color: 'success',
                        title: 'Success',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: res.data.message
                    })

                    this.$router.push({ name: 'delivery-order-view', params: {id: res.data.id} })                        
                })
                .catch(error => {
                    this.isLoading = false

                    const message = error.response.data.message ? error.response.data.message : 'Something went wrong'

                    this.$vs.notify({
                        color: 'danger',
                        title: 'Error',
                        iconPack: 'feather',
                        icon:'icon-x',
                        text: message
                    })
                })
            }
        },
        mounted(){
            this.fetchAllData()
        },
	}
</script>